import React from "react";
import { BarLoader } from "react-spinners";

const Loader = ({ pageLoader = false }) => {
  if (pageLoader)
    return (
      <div className=" w-full h-full z-50 flex items-center justify-center">
        <BarLoader color="#0d99ff" />
      </div>
    );

  return <BarLoader color="#0d99ff" />;
};

export default Loader;
